export default "__VITE_ASSET__9V$4ZnRA__"